import { ENV } from "@/core/config/env";

const form = [
  {
    path: ENV.BASE_URL + '/:tenant/:form_url',
    name: 'loginUser',
    component: () => import("@/view/pages/auth/login_pages/LoginUser.vue"),
  },

  {
    path: ENV.BASE_URL + '/:tenant/:form_url/forgot-password',
    name: 'forgot-password',
    component: () => import("@/view/pages/auth/ForgotPassword.vue"),
  },
  
  {
    path: ENV.BASE_URL + '/:tenant/:form_url/change-password',
    name: 'reset-password',
    component: () => import("@/view/pages/auth/ResetPassword.vue"),
  },
  {
    path: ENV.BASE_URL + '/:tenant/:form_url/:answer_id/:form_child_url',
    name: 'loginUserChild',
    component: () => import("@/view/pages/auth/login_pages/LoginUser.vue"),
  },
  {
    path: ENV.BASE_URL + '/:tenant/:form_url/:answer_id/:form_child_url/answer',
    name: "user-form-child-info",
    component: () => import("@/view/pages/itaku-info/Form")
  },
  {
    path: ENV.BASE_URL + '/:tenant/:form_url/:answer_id',
    name: "user-form-info",
    component: () => import("@/view/pages/itaku-info/Form")
  },
  {
    path: ENV.BASE_URL + '/:tenant/:form_url/guest',
    name: "user-form-info-no-check",
    component: () => import("@/view/pages/itaku-info/Form")
  }
]

export default form
